
import Clipboard from "clipboard";
import {
  defineComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref
} from "vue";
import Timer from "../timer.vue";
import Icon from "../icon.vue";
import router from "@/router";
import Agora from "@/assets/common/Agora";

export default defineComponent({
  name: "room-header",
  props: {
    name: String
  },
  components: { Timer, Icon },
  setup() {
    const agora: Agora | null = window.agora;
    const href = ref("");
    let clipboard: any = null;

    // 退出频道
    function exit() {
      agora?.dispose();
      router.back();
    }

    // 注册剪切板
    function registerClip() {
      clipboard = new Clipboard(".share");

      clipboard.on("success", function(e: any) {
        window.message.success("频道已复制到剪切板");
        e.clearSelection();
      });

      clipboard.on("error", function(e: any) {
        window.message.error("复制频道失败");
        window.logger.log("error", e);
      });
    }

    onMounted(() => {
      nextTick(() => {
        registerClip();
        href.value = location.href;
      });
    });

    onBeforeUnmount(() => {
      clipboard?.destroy();
    });

    return {
      href,
      clipboard,
      exit
    };
  }
});
